import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { Injectable } from "@angular/core";
import { ApiService } from "projects/brain/src/app/services";
import { ProductDetails } from "@brain/models";
import { catchError, take } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class AssetDetailResolver implements Resolve<ProductDetails> {
    constructor(private apiService: ApiService) {}

    resolve(activatedRoute: ActivatedRouteSnapshot): Observable<ProductDetails> {
        const id = activatedRoute.params?.productId;
        const catalogName = activatedRoute.data?.catalog ?? "global";

        if (id && catalogName) {
            const asset = this.apiService.getProduct(id, catalogName);

            /**
       * fetch and store asset contact in session storage
       */
            this.apiService
                .getProductContacts(id, catalogName)
                .pipe(
                    catchError(() => of([])),
                    take(1)
                )
                .subscribe((contacts) =>
                    sessionStorage.setItem("asset_contacts", JSON.stringify(contacts))
                );

            return asset;
        }

        return EMPTY;
    }
}
